import { AxiosError } from 'axios'

import { ErrorCodesToMessages, HTTPStatusCodes } from 'common/interfaces'

export const HTTPErrorCodesToMessagesMap: ErrorCodesToMessages = {
  0: 'Network error. Please check your internet connection.',
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  405: 'Method not allowed',
  407: 'Proxy Authentication Required',
  408: 'Request Timeout',
  409: 'The request could not be completed due to a conflict with the current state of the target resource.',
  410: 'Access to the requested page or resource is no longer available.',
  412: 'Precondition Failed',
  413: 'Your file is too large. Max upload size is 20Mb.',
  414: 'URI is too long',
  415: 'Unsupported media type',
  500: 'Something went wrong. Please try again later.',
}

export default async function (err: AxiosError): Promise<AxiosError> {
  if (
    err.response?.status !== undefined &&
    Object.keys(HTTPErrorCodesToMessagesMap).includes(err.response.status.toString())
  ) {
    const statusCode = err.response.status.toString() as HTTPStatusCodes
    err.message = HTTPErrorCodesToMessagesMap[statusCode]
  }

  return await Promise.reject(err) // eslint-disable-line no-return-await
}
